import { render, staticRenderFns } from "./AdGalleries.vue?vue&type=template&id=1eda6401&scoped=true"
import script from "./AdGalleries.vue?vue&type=script&lang=js"
export * from "./AdGalleries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eda6401",
  null
  
)

export default component.exports